// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `section {
    max-width: 1920px;
    width: 100%;
}



#nosotros-evolucion-360 .BGNaranja,
#nosotros-aliado360 .BGNaranja {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 24px;
  color: #ffffff;
  font-weight: 600;
  font-size: 18px;
  text-decoration: none;
  border-radius: 8px;
  letter-spacing: 0.3px;
  position: relative;
  overflow: hidden;
  transition: transform 0.25s ease, box-shadow 0.25s ease;

  /* Animación automática */
  animation: pulseSoft 12s ease-in-out infinite;
}

/* HOVER */
#nosotros-evolucion-360 .BGNaranja:hover,
#nosotros-aliado360 .BGNaranja:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 10px black;
}

/* Glow hover */
#nosotros-evolucion-360 .BGNaranja::before,
#nosotros-aliado360 .BGNaranja::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    120deg,
    transparent,
    rgba(255, 255, 255, 0.35),
    transparent
  );
  transform: translateX(-100%);
  transition: transform 0.6s ease;
}

#nosotros-evolucion-360 .BGNaranja:hover::before,
#nosotros-aliado360 .BGNaranja:hover::before {
  transform: translateX(100%);
}

/* Shine automático cada 12s */
#nosotros-evolucion-360 .BGNaranja::after,
#nosotros-aliado360 .BGNaranja::after {
  content: "";
  position: absolute;
  top: 0;
  left: -120%;
  width: 120%;
  height: 100%;
  background: linear-gradient(
    120deg,
    transparent,
    rgba(255, 255, 255, 0.25),
    transparent
  );
  animation: shine 12s ease-in-out infinite;
}

/* Click */
#nosotros-evolucion-360 .BGNaranja:active,
#nosotros-aliado360 .BGNaranja:active {
  transform: scale(0.97);
}

/* Pulse suave */
@keyframes pulseSoft {
  0% {
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.3);
    transform: scale(1);
  }
  4% {
    box-shadow: 0 12px 22px rgba(0, 0, 0, 0.45);
    transform: scale(1.015);
  }
  8% {
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.3);
    transform: scale(1);
  }
  100% {
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.3);
  }
}

/* Shine timing */
@keyframes shine {
  0% {
    left: -120%;
  }
  5% {
    left: 120%;
  }
  100% {
    left: 120%;
  }
}

img {
    object-fit: cover;
}

#nosotros-header img, #nosotros-empresas-alto-nivel img {
    width: 100%;
    height: auto;
    position: relative;
    z-index: 1;
}

#nosotros-header figcaption {
    z-index: 2;
    max-width: 669px;
    display: flex;
    gap: 24px;
    flex-direction: column;
    filter: drop-shadow(19px 31px 19px black);
}
#nosotros-evolucion-360 {
    position: relative;
}
.BGBlanco {
    background: white;
}
#nosotros-acelera-impulsa {
    display: flex;
    padding: 12px 0px 24px;
    gap: 12px;
}

#nosotros-acelera-impulsa img {
    width: 100%;
}

#nosotros-evolucion-360 figure {
    display: flex;
    gap: 24px 53px;
    width: 100%;
    justify-content: space-between;
}

#nosotros-evolucion-360 figcaption {
    width: auto;
    display: flex;
    flex-direction: column;
    gap: 24px;
}

#nosotros-diferente > :nth-child(2) {
    display: flex;
    gap: 18px 14px;
}

#nosotros-aliado360 figure {
    display: flex;
    align-items: center;
    gap: 26px;
    max-width: 1294px;
}

#nosotros-empresas-alto-nivel figure, #nosotros-empresas-alto-nivel img{
    position: relative;
}

#nosotros-empresas-alto-nivel figcaption {
    position: absolute;
    z-index: 2;
    top: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
#nosotros-acelera-impulsa figcaption {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

#nosotros-diferente > :nth-child(2) div {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 27px 13px 11px;
    box-shadow: 0 0 32px 0 rgba(0, 0, 0, 0.15);
}
#nosotros-acelera-impulsa h2, #nosotros-evolucion-360 h2 {
    margin-bottom: 24px;
} 
#nosotros-aliado360 figcaption {
    display: flex;
    flex-direction: column;
    gap: 24px;
}
#nosotros-cierre{
    width: auto;
}

h1, h2, h3, h4, h5, h6, strong{
    font-weight: 700;
    line-height: 1.2em;
}

h3{
    font-size: 18px;
}

p, strong {
    font-size: 16px;
    line-height: 1.4em;
}

#nosotros-diferente h2, #nosotros-diferente > :nth-child(1) p {
    text-align: center;
}

#nosotros-diferente h2, #nosotros-diferente > :nth-child(1) p{
    margin-bottom: 24px;
}

#nosotros-cierre h2, #nosotros-empresas-alto-nivel h2 {
        text-align: center;
}

#nosotros-diferente span.BGAzul {
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    font-size: 18px;
    font-weight: 700;
    position: unset;
}

#nosotros-diferente span.BGAzul::after {
    content: '';
    height: 2px;
    background-color: var(--azul);
    position: absolute;
    z-index: 0;
    left: 63px;
    right: 13px;
}
#nosotros-diferente span.BGAzul::before {
    content: '';
    width: 6px;
    height: 6px;
    background-color: var(--azul);
    position: absolute;
    z-index: 1;
    border-radius: 50%;
    right: 13px;
}

#nosotros-empresas-alto-nivel img {
        filter: brightness(0.65);
    }
#nosotros-acelera-impulsa h2::after, #nosotros-evolucion-360 h2::after {
    content: '';
    width: 282px;
    height: 12px;
    background-color: var(--azul);
    display: block;
    position: absolute;
    bottom: -30px;
}

@media (min-width: 1024px) {
    #nosotros-diferente > :nth-child(2) div {
        flex: 1 1;
    }
}

@media (max-width: 1024px) {
    #nosotros-diferente > :nth-child(2) {
        flex-wrap: wrap;
    }
}

@media (min-width: 768px) {
    #nosotros-cierre {
        margin: 50px 50px 20px;
    }
    #nosotros-diferente{
        padding: 0px 50px;
    }
    #nosotros-aliado360 {
        margin: 68px 0px;
    }
    #nosotros-evolucion-360 figcaption {
        max-width: 509px;
        padding-left: 48px;
    }
    #nosotros-empresas-alto-nivel figcaption {
        max-width: 559px;
        gap: 30px;
        left: 72px;
    }
    #nosotros-aliado360 figcaption {
        max-width: 559px;
    }
    #nosotros-evolucion-360 img {
        min-width: 354px;
        max-width: 827px;
        width: 100%;
    }
    #nosotros-aliado360 img {
        min-width: 350px;
        width: auto;
        max-width: 709px;
    }
    #nosotros-header figcaption {
        position: absolute;
        top: 62px;
        padding: 24px 50px;
    }
    #nosotros-header figure {
        display: flex;
        flex-wrap: wrap;
    }
    #nosotros-acelera-impulsa figcaption {
        padding: 24px 48px 12px;
    }
    h1, h2{
        font-size: 36px;
    }
    #nosotros-header img {
        height: calc(100dvh - 80px);
    }
    #nosotros-evolucion-360 {
        margin-bottom: 88px;
    }
    #nosotros-evolucion-360 h2 {
        width: 311px;
    }
    #nosotros-empresas-alto-nivel h2{
        margin-bottom: 39px;
    }
}

@media (max-width: 768px) {
    #nosotros-empresas-alto-nivel figcaption{
        padding: 24px;
        gap: 15px;
    }
    h2 {
        font-size: 32px;
    }
     p, strong {
        font-size: 14px;
    }

    #nosotros-evolucion-360 img, #nosotros-acelera-impulsa img, #nosotros-acelera-impulsa img, #nosotros-aliado360 img {
        width: 100%;
        height: 226px;
    }
    #nosotros-empresas-alto-nivel img {
        height: 384px;
    }
    #nosotros-empresas-alto-nivel h2{
        margin-bottom: 10px;
    }
    #nosotros-evolucion-360 {
        margin-bottom: 18px;
    }
    h1, h2{
        font-size: 32px;
        text-align: center;
    }
    #nosotros-aliado360 figcaption{
        padding: 0px 24px 24px;
    }
    #nosotros-cierre {
        margin: 24px;
    }
    #nosotros-diferente{
        padding: 24px;
    }
    #nosotros-aliado360{
        max-width: 100%;
        width: auto;
    }
    #nosotros-evolucion-360 figcaption{
        padding: 0px 24px 24px;
    }
    #nosotros-acelera-impulsa figcaption {
        padding: 24px;
    }
    #nosotros-acelera-impulsa, #nosotros-aliado360 figure{
        flex-wrap: wrap;
    }
    #nosotros-evolucion-360 figure{
        flex-wrap: wrap-reverse;
    }
    #nosotros-header figure {
        display: flex;
        flex-wrap: wrap;
    }
    #nosotros-aliado360 img {
        max-width: 100%;
    }
    #nosotros-header figcaption{
        padding: 16px 24px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Nosotros.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,WAAW;AACf;;;;AAIA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,uDAAuD;;EAEvD,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA,UAAU;AACV;;EAEE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA,eAAe;AACf;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;;;;GAKC;EACD,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA,8BAA8B;AAC9B;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,yCAAyC;AAC3C;;AAEA,UAAU;AACV;;EAEE,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE;IACE,yCAAyC;IACzC,mBAAmB;EACrB;EACA;IACE,2CAA2C;IAC3C,uBAAuB;EACzB;EACA;IACE,yCAAyC;IACzC,mBAAmB;EACrB;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,sBAAsB;IACtB,yCAAyC;AAC7C;AACA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,cAAc;IACd,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,0CAA0C;AAC9C;AACA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;AACA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;QACQ,kBAAkB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,6BAA6B;IAC7B,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,WAAW;AACf;AACA;IACI,WAAW;IACX,UAAU;IACV,WAAW;IACX,6BAA6B;IAC7B,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,WAAW;AACf;;AAEA;QACQ,wBAAwB;IAC5B;AACJ;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,cAAc;IACd,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI;QACI,SAAO;IACX;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,iBAAiB;IACrB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;IACA;QACI,gBAAgB;QAChB,SAAS;QACT,UAAU;IACd;IACA;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,WAAW;IACf;IACA;QACI,gBAAgB;QAChB,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,kBAAkB;QAClB,SAAS;QACT,kBAAkB;IACtB;IACA;QACI,aAAa;QACb,eAAe;IACnB;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,eAAe;IACnB;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,mBAAmB;IACvB;IACA;QACI,YAAY;IAChB;IACA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,SAAS;IACb;IACA;QACI,eAAe;IACnB;KACC;QACG,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,kBAAkB;IACtB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,YAAY;IAChB;IACA;QACI,aAAa;IACjB;IACA;QACI,eAAe;QACf,WAAW;IACf;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,aAAa;QACb,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":["section {\n    max-width: 1920px;\n    width: 100%;\n}\n\n\n\n#nosotros-evolucion-360 .BGNaranja,\n#nosotros-aliado360 .BGNaranja {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px 24px;\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 18px;\n  text-decoration: none;\n  border-radius: 8px;\n  letter-spacing: 0.3px;\n  position: relative;\n  overflow: hidden;\n  transition: transform 0.25s ease, box-shadow 0.25s ease;\n\n  /* Animación automática */\n  animation: pulseSoft 12s ease-in-out infinite;\n}\n\n/* HOVER */\n#nosotros-evolucion-360 .BGNaranja:hover,\n#nosotros-aliado360 .BGNaranja:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 10px black;\n}\n\n/* Glow hover */\n#nosotros-evolucion-360 .BGNaranja::before,\n#nosotros-aliado360 .BGNaranja::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    120deg,\n    transparent,\n    rgba(255, 255, 255, 0.35),\n    transparent\n  );\n  transform: translateX(-100%);\n  transition: transform 0.6s ease;\n}\n\n#nosotros-evolucion-360 .BGNaranja:hover::before,\n#nosotros-aliado360 .BGNaranja:hover::before {\n  transform: translateX(100%);\n}\n\n/* Shine automático cada 12s */\n#nosotros-evolucion-360 .BGNaranja::after,\n#nosotros-aliado360 .BGNaranja::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -120%;\n  width: 120%;\n  height: 100%;\n  background: linear-gradient(\n    120deg,\n    transparent,\n    rgba(255, 255, 255, 0.25),\n    transparent\n  );\n  animation: shine 12s ease-in-out infinite;\n}\n\n/* Click */\n#nosotros-evolucion-360 .BGNaranja:active,\n#nosotros-aliado360 .BGNaranja:active {\n  transform: scale(0.97);\n}\n\n/* Pulse suave */\n@keyframes pulseSoft {\n  0% {\n    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.3);\n    transform: scale(1);\n  }\n  4% {\n    box-shadow: 0 12px 22px rgba(0, 0, 0, 0.45);\n    transform: scale(1.015);\n  }\n  8% {\n    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.3);\n    transform: scale(1);\n  }\n  100% {\n    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.3);\n  }\n}\n\n/* Shine timing */\n@keyframes shine {\n  0% {\n    left: -120%;\n  }\n  5% {\n    left: 120%;\n  }\n  100% {\n    left: 120%;\n  }\n}\n\nimg {\n    object-fit: cover;\n}\n\n#nosotros-header img, #nosotros-empresas-alto-nivel img {\n    width: 100%;\n    height: auto;\n    position: relative;\n    z-index: 1;\n}\n\n#nosotros-header figcaption {\n    z-index: 2;\n    max-width: 669px;\n    display: flex;\n    gap: 24px;\n    flex-direction: column;\n    filter: drop-shadow(19px 31px 19px black);\n}\n#nosotros-evolucion-360 {\n    position: relative;\n}\n.BGBlanco {\n    background: white;\n}\n#nosotros-acelera-impulsa {\n    display: flex;\n    padding: 12px 0px 24px;\n    gap: 12px;\n}\n\n#nosotros-acelera-impulsa img {\n    width: 100%;\n}\n\n#nosotros-evolucion-360 figure {\n    display: flex;\n    gap: 24px 53px;\n    width: 100%;\n    justify-content: space-between;\n}\n\n#nosotros-evolucion-360 figcaption {\n    width: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n\n#nosotros-diferente > :nth-child(2) {\n    display: flex;\n    gap: 18px 14px;\n}\n\n#nosotros-aliado360 figure {\n    display: flex;\n    align-items: center;\n    gap: 26px;\n    max-width: 1294px;\n}\n\n#nosotros-empresas-alto-nivel figure, #nosotros-empresas-alto-nivel img{\n    position: relative;\n}\n\n#nosotros-empresas-alto-nivel figcaption {\n    position: absolute;\n    z-index: 2;\n    top: 0;\n    bottom: 0;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n#nosotros-acelera-impulsa figcaption {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n\n#nosotros-diferente > :nth-child(2) div {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    padding: 27px 13px 11px;\n    box-shadow: 0 0 32px 0 rgba(0, 0, 0, 0.15);\n}\n#nosotros-acelera-impulsa h2, #nosotros-evolucion-360 h2 {\n    margin-bottom: 24px;\n} \n#nosotros-aliado360 figcaption {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n#nosotros-cierre{\n    width: auto;\n}\n\nh1, h2, h3, h4, h5, h6, strong{\n    font-weight: 700;\n    line-height: 1.2em;\n}\n\nh3{\n    font-size: 18px;\n}\n\np, strong {\n    font-size: 16px;\n    line-height: 1.4em;\n}\n\n#nosotros-diferente h2, #nosotros-diferente > :nth-child(1) p {\n    text-align: center;\n}\n\n#nosotros-diferente h2, #nosotros-diferente > :nth-child(1) p{\n    margin-bottom: 24px;\n}\n\n#nosotros-cierre h2, #nosotros-empresas-alto-nivel h2 {\n        text-align: center;\n}\n\n#nosotros-diferente span.BGAzul {\n    width: 50px;\n    height: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    font-size: 18px;\n    font-weight: 700;\n    position: unset;\n}\n\n#nosotros-diferente span.BGAzul::after {\n    content: '';\n    height: 2px;\n    background-color: var(--azul);\n    position: absolute;\n    z-index: 0;\n    left: 63px;\n    right: 13px;\n}\n#nosotros-diferente span.BGAzul::before {\n    content: '';\n    width: 6px;\n    height: 6px;\n    background-color: var(--azul);\n    position: absolute;\n    z-index: 1;\n    border-radius: 50%;\n    right: 13px;\n}\n\n#nosotros-empresas-alto-nivel img {\n        filter: brightness(0.65);\n    }\n#nosotros-acelera-impulsa h2::after, #nosotros-evolucion-360 h2::after {\n    content: '';\n    width: 282px;\n    height: 12px;\n    background-color: var(--azul);\n    display: block;\n    position: absolute;\n    bottom: -30px;\n}\n\n@media (min-width: 1024px) {\n    #nosotros-diferente > :nth-child(2) div {\n        flex: 1;\n    }\n}\n\n@media (max-width: 1024px) {\n    #nosotros-diferente > :nth-child(2) {\n        flex-wrap: wrap;\n    }\n}\n\n@media (min-width: 768px) {\n    #nosotros-cierre {\n        margin: 50px 50px 20px;\n    }\n    #nosotros-diferente{\n        padding: 0px 50px;\n    }\n    #nosotros-aliado360 {\n        margin: 68px 0px;\n    }\n    #nosotros-evolucion-360 figcaption {\n        max-width: 509px;\n        padding-left: 48px;\n    }\n    #nosotros-empresas-alto-nivel figcaption {\n        max-width: 559px;\n        gap: 30px;\n        left: 72px;\n    }\n    #nosotros-aliado360 figcaption {\n        max-width: 559px;\n    }\n    #nosotros-evolucion-360 img {\n        min-width: 354px;\n        max-width: 827px;\n        width: 100%;\n    }\n    #nosotros-aliado360 img {\n        min-width: 350px;\n        width: auto;\n        max-width: 709px;\n    }\n    #nosotros-header figcaption {\n        position: absolute;\n        top: 62px;\n        padding: 24px 50px;\n    }\n    #nosotros-header figure {\n        display: flex;\n        flex-wrap: wrap;\n    }\n    #nosotros-acelera-impulsa figcaption {\n        padding: 24px 48px 12px;\n    }\n    h1, h2{\n        font-size: 36px;\n    }\n    #nosotros-header img {\n        height: calc(100dvh - 80px);\n    }\n    #nosotros-evolucion-360 {\n        margin-bottom: 88px;\n    }\n    #nosotros-evolucion-360 h2 {\n        width: 311px;\n    }\n    #nosotros-empresas-alto-nivel h2{\n        margin-bottom: 39px;\n    }\n}\n\n@media (max-width: 768px) {\n    #nosotros-empresas-alto-nivel figcaption{\n        padding: 24px;\n        gap: 15px;\n    }\n    h2 {\n        font-size: 32px;\n    }\n     p, strong {\n        font-size: 14px;\n    }\n\n    #nosotros-evolucion-360 img, #nosotros-acelera-impulsa img, #nosotros-acelera-impulsa img, #nosotros-aliado360 img {\n        width: 100%;\n        height: 226px;\n    }\n    #nosotros-empresas-alto-nivel img {\n        height: 384px;\n    }\n    #nosotros-empresas-alto-nivel h2{\n        margin-bottom: 10px;\n    }\n    #nosotros-evolucion-360 {\n        margin-bottom: 18px;\n    }\n    h1, h2{\n        font-size: 32px;\n        text-align: center;\n    }\n    #nosotros-aliado360 figcaption{\n        padding: 0px 24px 24px;\n    }\n    #nosotros-cierre {\n        margin: 24px;\n    }\n    #nosotros-diferente{\n        padding: 24px;\n    }\n    #nosotros-aliado360{\n        max-width: 100%;\n        width: auto;\n    }\n    #nosotros-evolucion-360 figcaption{\n        padding: 0px 24px 24px;\n    }\n    #nosotros-acelera-impulsa figcaption {\n        padding: 24px;\n    }\n    #nosotros-acelera-impulsa, #nosotros-aliado360 figure{\n        flex-wrap: wrap;\n    }\n    #nosotros-evolucion-360 figure{\n        flex-wrap: wrap-reverse;\n    }\n    #nosotros-header figure {\n        display: flex;\n        flex-wrap: wrap;\n    }\n    #nosotros-aliado360 img {\n        max-width: 100%;\n    }\n    #nosotros-header figcaption{\n        padding: 16px 24px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
